import { Skeleton, Stack, Typography } from '@mui/material';
import { ImageBox } from 'components';
import { useTranslation } from 'react-i18next';
import { FeedbackInfoProps } from 'types';

interface FeedbackInfoBoxProps {
	feedback?: FeedbackInfoProps;
}

const FeedbackInfoBox = ({ feedback }: FeedbackInfoBoxProps) => {
	const { t } = useTranslation();

	return (
		<>
			<Stack
				sx={{
					overflow: 'scroll',
					p: 3,
					pt: 1,
				}}
				spacing={3}
			>
				<Stack spacing={1}>
					<Typography variant="caption" sx={{ color: 'gray' }}>
						{t('user.pn')}
					</Typography>
					<Typography variant="body2">
						{feedback ? (
							feedback.tel
						) : (
							<Skeleton animation="wave" />
						)}
					</Typography>
				</Stack>
				<Stack spacing={1}>
					<Typography variant="caption" sx={{ color: 'gray' }}>
						{t('form.email')}
					</Typography>
					<Typography variant="body2">
						{feedback ? (
							feedback.email
						) : (
							<Skeleton animation="wave" />
						)}
					</Typography>
				</Stack>
				<Stack spacing={1}>
					<Typography variant="caption" sx={{ color: 'gray' }}>
						{t('feedback.title')}
					</Typography>
					<Typography variant="body2">
						{feedback ? (
							feedback.title
						) : (
							<Skeleton animation="wave" />
						)}
					</Typography>
				</Stack>
				<Stack spacing={1}>
					<Typography variant="caption" sx={{ color: 'gray' }}>
						{t('feedback.description')}
					</Typography>
					<Typography variant="body2">
						{feedback ? (
							feedback.content
						) : (
							<Skeleton animation="wave" />
						)}
					</Typography>
				</Stack>
				{feedback && feedback.imgs ? (
					<Stack spacing={1}>
						<Typography variant="caption" sx={{ color: 'gray' }}>
							{t('feedback.images')}
						</Typography>
						<Stack spacing={2} direction="row">
							{feedback.imgs.map((img: string, index: number) => (
								<ImageBox key={index} img={img} />
							))}
						</Stack>
					</Stack>
				) : null}
			</Stack>
		</>
	);
};

export default FeedbackInfoBox;
